import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "onChange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useMemo } from 'react';
import { useDerivedState } from '@deliveryhero/armor-system';
import { getValidTimeFragment } from '../utils/getValidTimeFragment';
export var useDatePickerTimeSelector = function useDatePickerTimeSelector(_ref, ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var value12 = useMemo(function () {
    return value.convertTo12();
  }, [value]);
  // todo: refactor this, leave only one state!
  var _useDerivedState = useDerivedState(function () {
      return value12.formattedHour;
    }, [value12]),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
    hourValue = _useDerivedState2[0],
    setHourValue = _useDerivedState2[1];
  var _useDerivedState3 = useDerivedState(function () {
      return value12.formattedMinute;
    }, [value12]),
    _useDerivedState4 = _slicedToArray(_useDerivedState3, 2),
    minuteValue = _useDerivedState4[0],
    setMinuteValue = _useDerivedState4[1];
  var _useDerivedState5 = useDerivedState(function () {
      return value12.mode;
    }, [value12]),
    _useDerivedState6 = _slicedToArray(_useDerivedState5, 2),
    mode = _useDerivedState6[0],
    setMode = _useDerivedState6[1];
  var onHourInputChange = useCallback(function (event) {
    var newHour = event.target.value;
    setHourValue(newHour);
  }, [setHourValue]);
  var onMinuteInputChange = useCallback(function (event) {
    var newMinute = event.target.value;
    setMinuteValue(newMinute);
  }, [setMinuteValue]);
  var onTimeInputFocus = useCallback(function (event) {
    event.target.select();
  }, []);
  var onTimeInputKeyDown = useCallback(function (event) {
    var keyCode = event.keyCode;
    if (keyCode !== 8 && keyCode !== 9 && keyCode !== 32 && (keyCode < 48 || keyCode > 57)) {
      event.preventDefault();
    }
  }, []);
  var onHourInputBlur = useCallback(function (event) {
    var newHour = event.target.value;
    var newHourInt = getValidTimeFragment(newHour, 12);
    if (newHourInt !== null) {
      onChange(value12.clone({
        hour: newHourInt
      }).convertTo24());
    }
  }, [onChange, value12]);
  var onMinuteInputBlur = useCallback(function (event) {
    var newMinute = event.target.value;
    var newMinuteInt = getValidTimeFragment(newMinute, 59);
    if (newMinuteInt !== null) {
      onChange(value12.clone({
        minute: newMinuteInt
      }).convertTo24());
    }
  }, [onChange, value12]);
  var onDayPeriodChange = useCallback(function (modeVal) {
    setMode(modeVal);
    onChange(value12.clone({
      mode: modeVal
    }).convertTo24());
  }, [onChange, setMode, value12]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: ref
    }),
    hourInputProps: {
      value: hourValue,
      onChange: onHourInputChange,
      onFocus: onTimeInputFocus,
      onBlur: onHourInputBlur,
      onKeyDown: onTimeInputKeyDown,
      maxLength: 2
    },
    minuteInputProps: {
      value: minuteValue,
      onChange: onMinuteInputChange,
      onFocus: onTimeInputFocus,
      onBlur: onMinuteInputBlur,
      onKeyDown: onTimeInputKeyDown,
      maxLength: 2
    },
    buttonDayPeriodProps: {
      switchName: mode,
      onSwitchNameChange: function onSwitchNameChange(modeVal) {
        return onDayPeriodChange(modeVal);
      }
    }
  };
};